import React from "react";
import { Row, Column, Button, Colors } from "react-foundation";

import Logo from "components/Logo";
import { connect } from "react-redux";
import ThemeButton from "../../components/ThemeButton";

const WantPrice = props => {
    const noHandler = () => {
        if (props.Customer.Type === "DGN") {
            props.history.push("/GetQuote/SaveForLater");
        } else {
            props.history.push("/GetQuote/EmailUnpricedQuote");
        }
    };

    const yesHandler = () => {
        if (props.Customer.Type === "DGN") {
            props.history.push("/GetQuote/Postcode");
        } else {
            props.history.push("/GetQuote/RedirectToDGN");
        }
    };

    let windowCount = props.ProductList.filter(p => p.ItemType.Name === "Window").length;
    let doorCount = props.ProductList.filter(p => p.ItemType.Name === "Door").length;
    let totalCount = props.ProductList.length;

    var text = "";

    if (windowCount === 1 && totalCount === 1)
        text = "Great, you’ve designed your perfect window. Why don’t you see how much it’d be to get installed…";

    if (doorCount === 1 && totalCount === 1)
        text = "Great, you’ve designed your perfect door. Why don’t you see how much it’d be to get installed…";

    if (windowCount >= 2 && doorCount === 0)
        text = "Great, you’ve designed your perfect windows. Why don’t you see how much they’d be to get installed…";

    if (doorCount >= 2 && windowCount === 0)
        text = "Great, you’ve designed your perfect doors. Why don’t you see how much they’d be to get installed…";

    if (doorCount >= 1 && windowCount >= 1)
        text = "Great, you’ve designed your perfect windows and doors. Why don’t you see how much they’d be to get installed…";



    return (
        <div style={{ position: "relative" }}>
            <Logo topLeft={true} />
            <Row className="top-padding-page">
                <Column large={4} medium={8} small={12} centerOnSmall>
                    <h3>Do you want a price?</h3>
                    <p>
                        {
                            text
                        }
                    </p>
                    <Button onClick={noHandler} isHollow color={Colors.SECONDARY}>
                        No, Thanks
                    </Button>
                    <ThemeButton  onClick={yesHandler}>
                        Yes, Please show me
                    </ThemeButton>
                </Column>
            </Row>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        Customer: state.TradeCustomer,
        ProductList: state.ProductList
    };
};

export default connect(mapStateToProps, {})(WantPrice);



// WEBPACK FOOTER //
// ./src/containers/QuoteForm/WantPrice.js